// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".item{margin:20px;width:324px;height:184px;background:gray;background-size:cover}.item .index{position:absolute;padding:5px;padding-right:8px;padding-left:8px;background:#000;font-size:9px}.item img,.item video{width:100%;height:100%}.item .info{width:100%;display:flex}.item .info input{width:80%}.item .info button{width:20%;color:#fff;background-color:#141a23}", ""]);
// Exports
module.exports = exports;
